class TootoAboutIntro extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.heroImage = this.querySelector('[data-tooto-about-hero-image]');
    this.storyVisual = this.querySelector('[data-tooto-about-story-visual]');

    if (this.dataset.animationEnabled !== 'true' || this.reducedMotion) {
      this.revealAll();
      return;
    }

    this.revealHero = () => {
      if (!this.isConnected || this.classList.contains('is-hero-visible')) return;
      requestAnimationFrame(() => this.classList.add('is-hero-visible'));
    };

    if (!this.heroImage || this.heroImage.tagName !== 'IMG' || this.heroImage.complete) {
      this.revealHero();
    } else {
      this.heroImage.addEventListener('load', this.revealHero, { once: true });
      this.heroImage.addEventListener('error', this.revealHero, { once: true });
      this.heroFallbackTimer = window.setTimeout(this.revealHero, 1400);
    }

    if (!this.storyVisual || !('IntersectionObserver' in window)) {
      this.classList.add('is-story-visible');
      return;
    }

    this.storyObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-story-visible');
        this.storyObserver.disconnect();
      },
      { threshold: 0.22, rootMargin: '0px 0px -8% 0px' }
    );
    this.storyObserver.observe(this.storyVisual);
  }

  disconnectedCallback() {
    this.heroImage?.removeEventListener('load', this.revealHero);
    this.heroImage?.removeEventListener('error', this.revealHero);
    this.storyObserver?.disconnect();
    window.clearTimeout(this.heroFallbackTimer);
  }

  revealAll() {
    this.classList.add('is-hero-visible', 'is-story-visible');
  }
}

if (!customElements.get('tooto-about-intro')) {
  customElements.define('tooto-about-intro', TootoAboutIntro);
}
